import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyOtherCountriesDto } from '../../models/api/companyOtherCountriesDto';
import { UpsertCompanyOtherCountriesRequest } from '../../models/api/upsertCompanyOtherCountriesRequest';

@Injectable({
  providedIn: 'root'
})
export class CompanyOtherCountriesService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<CompanyOtherCountriesDto> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<CompanyOtherCountriesDto>(`${this.apiUrl}/${companyId}/other-countries`, { params });
  }

  upsert(companyId: string, request: UpsertCompanyOtherCountriesRequest): Observable<CompanyOtherCountriesDto> {
    return this.http.put<CompanyOtherCountriesDto>(`${this.apiUrl}/${companyId}/other-countries`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/other-countries`, { params });
  }
}
